//I stole this from a google search:
//  https://www.thekrazydev.com/how-to-open-a-dropdown-menu-on-hover-in-react/
import React from 'react'
import { Link } from 'react-router-dom'

const NavLinksHomeDropdown = () => {
	return (
		<>
			<div
				className='dropdown'
				style={{
					position: 'absolute',
					background: 'white',
					marginTop: '0rem',
					cursor: 'pointer',
					height: '3.2rem',
					borderRadius: '2px',
				}}
			>
				<a
					href='https://murrysvillesportzone.com/'
					//to='https://murrysvillesportzone.com/'
					style={{
						paddingTop: '.1rem',
						paddingBottom: '.1rem',
						color: 'black',
					}}
				>
					MURRYSVILLE
				</a>
				<br></br>
				<a
					href='https://mtpleasantsportzone.com/'
					//to='https://mtpleasantsportzone.com/'
					style={{
						display: 'block',
						paddingTop: '.1rem',
						paddingBottom: '.1rem',
						color: 'black',
					}}
				>
					MOUNT PLEASANT
				</a>
			</div>
		</>
	)
}

export default NavLinksHomeDropdown
